import { DefineComponentProps } from 'utils'
import { HocElDialog, HocElDialogFooterLayout } from '../hoc-element-components/HocElDialog'
import { useDialog } from '../stores/use-dialog'
import { DialogHeader } from '../components/DialogHeader'
import { CustomButton } from '../components/Button'
import { useI18n } from 'i18n-utils'
import { ListCell } from '../components/ListCell'
import { PLATFORM_CONFIG } from 'platform-config'
import { Tag } from '../components/Tag'
import { useProjectTheme } from 'store'
import './ExchangeConfirm.scss'

type CellItem = {
  label: string
  value: string
}

export type ExchangeConfirmProps = {
  /** 是否是冰山委托 */
  isIce?: boolean
  title?: string
  direction?: {
    text: string
    color?: string
    isTag?: boolean
  }
  cellList?: CellItem[]
  leverage?: string
  onClose?: () => void
  onConfirm?: () => Promise<void>
}


export const ExchangeConfirm = defineComponent<ExchangeConfirmProps>({
  props: DefineComponentProps<ExchangeConfirmProps>(['isIce', 'title', 'direction', 'cellList', 'leverage', 'onClose', 'onConfirm']),
  setup(props) {
    const { dialogVisible, openDialog, closeDialog } = useDialog()
    const loading = ref(false)
    const { t } = useI18n()
    const themeStore = useProjectTheme()

    onBeforeMount(() => {
      openDialog()
    })

    const onClose = () => {
      closeDialog()
      props.onClose?.()
    }

    const onConfirm = async () => {
      if (loading.value) return
      loading.value = true
      await props.onConfirm?.()
      loading.value = false
      onClose()
    }

    return () => (
      <HocElDialog v-model={dialogVisible.value} showClose={false} width={400} placement={'bottom'}>
        {{
          header: () => (
            <DialogHeader onClose={onClose}>
              <div class="flex gap-row-8">{props.title}</div>
              <div class="flex gap-row-8">
                {props.direction?.isTag && <Tag color={props.direction?.color || ''}>{props.direction?.text}</Tag>}
                {props.leverage && (
                  <Tag color={themeStore.theme.colors.text.base} bgColor={themeStore.theme.colors.bg.tag.base}>
                    {props.leverage}
                  </Tag>
                )}
                {props.isIce && (
                  <Tag color={themeStore.theme.colors.text.base} bgColor={themeStore.theme.colors.bg.tag.base}>
                    {t('冰山委托')}
                  </Tag>
                )}
              </div>
            </DialogHeader>
          ),
          default: () => (
            <div class="exchange-confirm-layout exchange-confirm-content">
              <div class="cell-list">{props.cellList?.map((item) => <ListCell title={item.label} description={item.value} />)}</div>
              <div class="tips">
                <img src={PLATFORM_CONFIG.alertIcon} width={16} alt="alert" class="alert-icon" />
                <span class="tips-title">{t('请注意：大额交易可能会受市场影响产生较大滑点')}</span>
              </div>
            </div>
          ),
          footer: () => (
            <HocElDialogFooterLayout>
              <CustomButton type="primary" loading={loading.value} onClick={onConfirm}>
                {t('确定')}
              </CustomButton>
            </HocElDialogFooterLayout>
          ),
        }}
      </HocElDialog>
    )
  },
})
